// extracted by mini-css-extract-plugin
export var equalColumn = "_fs-0";